export default function buildLocation(addresses, item) {
  let location;
  if (addresses && addresses.length > 0) {
    location = addresses[0].city + ', ' + addresses[0].state;
    if (addresses.length > 1) {
      location += ' & ' + (addresses.length - 1) + ' more';
    }
  } else if (item && item.city) {
    return item.city + ', ' + item.state;
  }
  return location;
}



// WEBPACK FOOTER //
// ./src/helpers/buildLocation.js